import { CmdAsset } from './CmdAsset';
import { CmdWidget } from './CmdWidget';
export class CmdListItem extends CmdWidget{
    
    label: string;
    asset: CmdAsset;
}